import PageContent from "@components/PageContent";
import PageHeader from "@components/PageHeader";
import { APP_NAME } from "@utils/constants";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useNavigate, useParams } from "react-router-dom";
import Input from "@components/Input";
import Checkbox from "@components/Checkbox";
import Button from "@components/Button";
import { useDispatch, useSelector } from "react-redux";
import shippingPartnerSlice, {
  clearOne,
  setOneValue,
} from "@features/admin/shipping/shippingPartner/shippingPartnerSlice";
import { useInjectReducer } from "@app/store";
import { makeSelectOne } from "@features/admin/shipping/shippingPartner/shippingPartnerSelector";
import {
  useLoadOneShippingPartnerMutation,
  useSaveShippingPartnerMutation,
} from "@features/admin/shipping/shippingPartner/shippingPartnerApiSlice";
import { enqueueSnackbar } from "@features/auth/authSlice";

const ShippingPartnerAddEdit = () => {
  useInjectReducer("shippingPartner", shippingPartnerSlice);
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const one = useSelector(makeSelectOne);

  //trk
  const [saveShippingPartner, { isLoading: saveLoading }] =
    useSaveShippingPartnerMutation();

  const [
    oneShippingPartner,
    { data: oneShippingPartnerData, isLoading: loading, isSuccess: success },
  ] = useLoadOneShippingPartnerMutation();

  useEffect(() => {
    if (id) {
      oneShippingPartner(id);
    } else {
      dispatch(clearOne());
    }
  }, []);

  const handleBack = () => {
    navigate("/admin/shipping-partner");
  };

  const handleChange = (name) => (e) => {
    dispatch(setOneValue({ key: name, value: e.target.value }));
  };

  const handleCheckedChange = (name) => (event) => {
    dispatch(setOneValue({ key: name, value: event.target.checked }));
  };

  const handleSave = () => {
    let data = {
      ...one,
    };
    saveShippingPartner(data)
      .unwrap()
      .then((res) => {
        if (res?.success) {
          dispatch(
            enqueueSnackbar({
              message: res?.msg ?? "Shipping Partner Saved",
              options: { variant: "success" },
            })
          );
          navigate("/admin/shipping-partner");
          dispatch(clearOne());
        }
      })
      .catch((err) => {
        if (err?.data?.msg) {
          dispatch(
            enqueueSnackbar({
              message: err?.data?.msg ?? "Brand Save Failed",
              options: {
                variant: "warning",
              },
            })
          );
        }
      });
  };
  return (
    <>
      <Helmet>
        <title>{`${id ? "Edit" : "Add"} Shipping Partner : ${APP_NAME}`}</title>
      </Helmet>
      <PageHeader
        title={`${id ? "Edit" : "Add"} Shipping Partner `}
        isBack
        handleGoBack={handleBack}
      />
      <PageContent>
        <div className="bg-white p-4 border border-gray-300">
          <div className="w-full">
            <Input
              label="Name"
              inputClassName="inputbox"
              value={one?.name || ""}
              onChange={handleChange("name")}
              //   error={errors.name}
            />
          </div>
          <div className="w-full">
            <Input
              label="Contact Person"
              inputClassName="inputbox"
              id="grid-contact-person"
              type="text"
              value={one?.contact_person || ""}
              onChange={handleChange("contact_person")}
              //   error={errors.contact_person}
            />
          </div>
          <div className="w-full">
            <Input
              label="Order"
              inputClassName="inputbox"
              id="grid-order"
              type="number"
              value={one?.order}
              onChange={handleChange("order")}
              //   error={errors.order}
            />
          </div>
          <div className="w-full">
            <Input
              label="Logic Code"
              inputClassName="inputbox"
              id="grid-logic-code"
              type="text"
              value={one?.logic_code}
              onChange={handleChange("logic_code")}
              //   error={errors.logic_code}
            />
          </div>
          <div className="w-full">
            <Checkbox
              label={"Is Active"}
              name={"is_active"}
              onChange={handleCheckedChange("is_active")}
              checked={one.is_active || false}
            />
          </div>
          <div>
            <Button type="button" className="mt-2" onClick={handleSave}>
              Save
            </Button>
          </div>
        </div>
      </PageContent>
    </>
  );
};

export default ShippingPartnerAddEdit;
